// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e54c5608","382":"515058d5","438":"5739f5fc","453":"619f91c1","505":"ca0aeb38","642":"d25d571e","746":"9f30a5e2","760":"fb1b5ea2","846":"e8cfe48d"}[chunkId] + ".chunk.js";
};